import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {Bold} from '../atoms/Text';
import {Tooltip} from '@material-ui/core';

const Container = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const SystemTitle = ({id, positionKnown}) => (
  <Container href={positionKnown && `/map?system=${id}`} style={{cursor: !positionKnown && 'auto'}}>
    <Bold style={{fontSize: '40px'}}>{id}</Bold>
    <Tooltip
      placement="right"
      title="System location unknown"
      disableHoverListener={positionKnown}
    >
      <img
        src="/assets/maps-marker.png"
        style={{height: '32px', marginLeft: '10px', opacity: !positionKnown && 0.3}}
        alt="Map marker, link to map"
      />
    </Tooltip>
  </Container>
);

SystemTitle.propTypes = {
  id: PropTypes.string,
  positionKnown: PropTypes.bool
};

export default SystemTitle;
